import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './assets/styles/Theme10.css';
import './assets/styles/Reset.css';
import './assets/styles/App.css';

import LoginPage from 'form/dashboard/LoginPage';
import Dashboard from 'form/dashboard/panel';
import { RootProvider } from 'contexts/RootContext';
import { IntakeProvider } from 'contexts/IntakeContext';
import { AppointmentProvider } from 'contexts/AppointmentContext';

import ListRoute from 'components/layout/ListRoute';
import FormRoute from 'components/layout/FormRoute';
import PrintRoute from 'components/layout/PrintRoute';
import CalendarRoute from 'components/layout/CalendarRoute';

import { 
  UserList, UserForm, 
  ClientList, ClientForm, FamilyList, ClientMerge, FamilyCredit,
  InvoiceList, InvoiceForm, InvoicePrint, 
  PaymentList, PaymentForm, 
  RoleList, RoleForm, 
  CityList, CityForm, 
  AppointmentList, AppointmentForm, 
  BankList, BankForm, 
  BillingList, BillingForm, BillingMultiForm,
  BrandList, BrandForm, 
  CategoryList, CategoryForm, 
  ExamList, ExamForm, ExamCompareForm,
  ExamTemplateList, ExamTemplateForm,
  CompanyList, CompanyForm, 
  CreditList, CreditForm, 
  OfferList, OfferForm, 
  RecDoctorList, RecDoctorForm, 
  DoctorList, DoctorForm, 
  DocumentList, DocumentForm, DocumentPrint, 
  EstimateList, EstimateForm, EstimatePrint,
  DeliveryList, DeliveryForm, DeliveryPrint,
  InsuranceList, InsuranceForm, 
  InsurerList, InsurerForm, 
  InquiryList, InquiryForm, 
  LocationList, LocationForm, 
  NoteList, NoteForm, 
  OptionList, OptionForm, 
  PayoutList, PayoutForm, 
  ProductList, ProductForm, 
  ProformaList, ProformaForm, ProformaPrint,
  RecallList, RecallForm, 
  ScheduleList, ScheduleForm, 
  SegmentList, SegmentForm, 
  SupplierList, SupplierForm, 
  IntakeList, IntakeForm, 
  PayeeList, PayeeForm, 
  TasksList, TasksForm, 
  TaxList, TaxForm, 
  ServerList, ServerForm, 
  DatabaseList, DatabaseForm, 
  DispenseList, DispenseForm,  DispensePrint,
  ReleaseList, ReleaseForm, ReleasePrint,
  SubmitterList, SubmitterForm,
  MissingList, MissingForm, 
  UnitList, UnitForm, 
  ProjectList, ProjectForm, 
  DaybookList, DaybookForm,
  ReportList, ReportForm, ReportCustom,
  AppointmentCalendar, ScheduleCalendar,
  TemplateList, TemplateForm,
  ReferralList, ReferralForm, ReferralPrint,
  ClaimList, ClaimForm, 
  RemittanceList, RemittanceForm, 
  PurchaseList, PurchaseForm, PurchaseItem,
  PurchaseReturnForm, PurchaseReturnList,
  PurchaseCreditForm, PurchaseCreditList,
  ExamTypeList, ExamTypeForm,
  TermList, TermForm,
  OrdersList, OrdersForm, OrdersItem, OrdersPrint, LabOrderPrint,
  SaleList, SaleForm, SaleOrderForm, SaleItemForm, SalePrint,
  InventoryList, 
  ItemList,
  ConsentPrint11, ConsentPrint12, ConsentPrint13, ConsentPrint14, ConsentPrint15, 
  ConsentPrint16, ConsentPrint17,
  NoPrivilege,
} from 'helpers/ListFormImports'
import ExamPrint from 'form/medical/exam/ExamPrint';
import ExamPrint2 from 'form/medical/exam/ExamPrint2';
import ReportRoute from 'components/layout/ReportRoute';

import SignatureForm from 'form/sample/SignatureForm';
import DrawingPadDemo from 'form/sample/DrawingPadDemo';
import SaveToPdfPage from 'form/sample/SaveToPdfPage';
import SnipTool from 'form/sample/snipping';
import IntakeOnline from 'form/dashboard/IntakeOnline';
import AppointmentOnline from 'form/dashboard/AppointmentOnline';
import SendNotification from 'form/sample/SendNotification';

const App = () => {
  return (
    <Router>
        <Routes>
          
          <Route path="/" element={ <RootProvider> <LoginPage /> </RootProvider> } />
          <Route path="/dashboard" element={ <RootProvider> <Dashboard /> </RootProvider> } />
          <Route path="/intake-form/:keyId" element={ <IntakeProvider> <IntakeOnline /> </IntakeProvider> } />
          <Route path="/book-visit/:keyId" element={ <AppointmentProvider> <AppointmentOnline /> </AppointmentProvider> } />
          
          <Route path="/user" element={ <ListRoute Component={UserList} /> } />
          <Route path="/invoice" element={ <ListRoute Component={InvoiceList} /> } />
          <Route path="/payment" element={ <ListRoute Component={PaymentList} /> } />
          <Route path="/role" element={ <ListRoute Component={RoleList} /> } />
          <Route path="/city" element={ <ListRoute Component={CityList} /> } />
          <Route path="/appointment" element={ <ListRoute Component={AppointmentList} /> } />
          <Route path="/bank" element={ <ListRoute Component={BankList} /> } />
          <Route path="/billing" element={ <ListRoute Component={BillingList} /> } />
          <Route path="/brand" element={ <ListRoute Component={BrandList} /> } />
          <Route path="/category" element={ <ListRoute Component={CategoryList} /> } />
          <Route path="/client" element={ <ListRoute Component={ClientList} /> } />
          <Route path="/company" element={ <ListRoute Component={CompanyList} /> } />
          <Route path="/credit" element={ <ListRoute Component={CreditList} /> } />
          <Route path="/delivery" element={ <ListRoute Component={DeliveryList} /> } /> 
          <Route path="/offer" element={ <ListRoute Component={OfferList} /> } />
          <Route path="/recdoctor" element={ <ListRoute Component={RecDoctorList} /> } />
          <Route path="/doctor" element={ <ListRoute Component={DoctorList} /> } />
          <Route path="/document" element={ <ListRoute Component={DocumentList} /> } />
          <Route path="/estimate" element={ <ListRoute Component={EstimateList} /> } />
          <Route path="/exam" element={ <ListRoute Component={ExamList} /> } />
          <Route path="/examtemplate" element={ <ListRoute Component={ExamTemplateList} /> } />
          <Route path="/insurance" element={ <ListRoute Component={InsuranceList} /> } />
          <Route path="/insurer" element={ <ListRoute Component={InsurerList} /> } />
          <Route path="/inquiry" element={ <ListRoute Component={InquiryList} /> } />
          <Route path="/location" element={ <ListRoute Component={LocationList} /> } />
          <Route path="/note" element={ <ListRoute Component={NoteList} /> } />
          <Route path="/option" element={ <ListRoute Component={OptionList} /> } />
          <Route path="/payout" element={ <ListRoute Component={PayoutList} /> } />
          <Route path="/product" element={ <ListRoute Component={ProductList} /> } />
          <Route path="/project" element={ <ListRoute Component={ProjectList} /> } />
          <Route path="/proforma" element={ <ListRoute Component={ProformaList} /> } />
          <Route path="/recall" element={ <ListRoute Component={RecallList} /> } />
          <Route path="/schedule" element={ <ListRoute Component={ScheduleList} /> } />
          <Route path="/segment" element={ <ListRoute Component={SegmentList} /> } />
          <Route path="/supplier" element={ <ListRoute Component={SupplierList} /> } />
          <Route path="/intake" element={ <ListRoute Component={IntakeList} /> } />
          <Route path="/payee" element={ <ListRoute Component={PayeeList} /> } />
          <Route path="/tasks" element={ <ListRoute Component={TasksList} /> } />
          <Route path="/tax" element={ <ListRoute Component={TaxList} /> } />
          <Route path="/server" element={ <ListRoute Component={ServerList} /> } />
          <Route path="/database" element={ <ListRoute Component={DatabaseList} /> } />
          <Route path="/dispense" element={ <ListRoute Component={DispenseList} /> } />
          <Route path="/release" element={ <ListRoute Component={ReleaseList} /> } />
          <Route path="/submitter" element={ <ListRoute Component={SubmitterList} /> } />
          <Route path="/missing" element={ <ListRoute Component={MissingList} /> } />
          <Route path="/unit" element={ <ListRoute Component={UnitList} /> } />
          <Route path="/daybook" element={ <ListRoute Component={DaybookList} /> } />
          <Route path="/report" element={ <ListRoute Component={ReportList} /> } />
          <Route path="/template" element={ <ListRoute Component={TemplateList} /> } />
          <Route path="/referral" element={ <ListRoute Component={ReferralList} /> } />
          <Route path="/claim" element={ <ListRoute Component={ClaimList} /> } />
          <Route path="/remittance" element={ <ListRoute Component={RemittanceList} /> } />
          <Route path="/sale" element={ <ListRoute Component={SaleList} /> } />
          <Route path="/orders" element={ <ListRoute Component={OrdersList} /> } />
          <Route path="/purchase" element={ <ListRoute Component={PurchaseList} /> } />
          <Route path="/purchasereturn" element={ <ListRoute Component={PurchaseReturnList} /> } />
          <Route path="/purchasecredit" element={ <ListRoute Component={PurchaseCreditList} /> } />
          <Route path="/inventory" element={ <ListRoute Component={InventoryList} /> } />
          <Route path="/examtype" element={ <ListRoute Component={ExamTypeList} /> } />
          <Route path="/term" element={ <ListRoute Component={TermList} /> } />
         
          <Route path="/user/:keyId" element={ <FormRoute Component={UserForm} /> } />
          <Route path="/invoice/:keyId" element={ <FormRoute Component={InvoiceForm} /> } />
          <Route path="/payment/:keyId" element={ <FormRoute Component={PaymentForm} /> } />
          <Route path="/role/:keyId" element={ <FormRoute Component={RoleForm} /> } />
          <Route path="/city/:keyId" element={ <FormRoute Component={CityForm} /> } />
          <Route path="/appointment/:keyId" element={ <FormRoute Component={AppointmentForm} /> } />
          <Route path="/bank/:keyId" element={ <FormRoute Component={BankForm} /> } />
          <Route path="/billing/:keyId" element={ <FormRoute Component={BillingForm} /> } />
          <Route path="/multibilling/:keyId" element={ <FormRoute Component={BillingMultiForm} /> } />
          <Route path="/brand/:keyId" element={ <FormRoute Component={BrandForm} /> } />
          <Route path="/category/:keyId" element={ <FormRoute Component={CategoryForm} /> } />
          <Route path="/client/:keyId" element={ <FormRoute Component={ClientForm} /> } /> 
          <Route path="/company/:keyId" element={ <FormRoute Component={CompanyForm} /> } />
          <Route path="/credit/:keyId" element={ <FormRoute Component={CreditForm} /> } />
          <Route path="/delivery/:keyId" element={ <FormRoute Component={DeliveryForm} /> } />
          <Route path="/offer/:keyId" element={ <FormRoute Component={OfferForm} /> } />
          <Route path="/recdoctor/:keyId" element={ <FormRoute Component={RecDoctorForm} /> } />
          <Route path="/doctor/:keyId" element={ <FormRoute Component={DoctorForm} /> } />
          <Route path="/document/:keyId" element={ <FormRoute Component={DocumentForm} /> } />
          <Route path="/estimate/:keyId" element={ <FormRoute Component={EstimateForm} /> } />
          <Route path="/exam/:keyId" element={ <FormRoute Component={ExamForm} /> } />
          <Route path="/examtemplate/:keyId" element={ <FormRoute Component={ExamTemplateForm} /> } />
          <Route path="/compare/:keyId" element={ <FormRoute Component={ExamCompareForm} /> } />
          <Route path="/insurance/:keyId" element={ <FormRoute Component={InsuranceForm} /> } />
          <Route path="/insurer/:keyId" element={ <FormRoute Component={InsurerForm} /> } />
          <Route path="/inquiry/:keyId" element={ <FormRoute Component={InquiryForm} /> } />
          <Route path="/location/:keyId" element={ <FormRoute Component={LocationForm} /> } />
          <Route path="/note/:keyId" element={ <FormRoute Component={NoteForm} /> } />
          <Route path="/option/:keyId" element={ <FormRoute Component={OptionForm} /> } />
          <Route path="/payout/:keyId" element={ <FormRoute Component={PayoutForm} /> } />
          <Route path="/product/:keyId" element={ <FormRoute Component={ProductForm} /> } />
          <Route path="/project/:keyId" element={ <FormRoute Component={ProjectForm} /> } />
          <Route path="/proforma/:keyId" element={ <FormRoute Component={ProformaForm} /> } />
          <Route path="/recall/:keyId" element={ <FormRoute Component={RecallForm} /> } />
          <Route path="/schedule/:keyId" element={ <FormRoute Component={ScheduleForm} /> } />
          <Route path="/segment/:keyId" element={ <FormRoute Component={SegmentForm} /> } />
          <Route path="/supplier/:keyId" element={ <FormRoute Component={SupplierForm} /> } />
          <Route path="/intake/:keyId" element={ <FormRoute Component={IntakeForm} /> } />
          <Route path="/payee/:keyId" element={ <FormRoute Component={PayeeForm} /> } />
          <Route path="/tasks/:keyId" element={ <FormRoute Component={TasksForm} /> } />
          <Route path="/tax/:keyId" element={ <FormRoute Component={TaxForm} /> } />
          <Route path="/server/:keyId" element={ <FormRoute Component={ServerForm} /> } />
          <Route path="/database/:keyId" element={ <FormRoute Component={DatabaseForm} /> } />
          <Route path="/dispense/:keyId" element={ <FormRoute Component={DispenseForm} /> } />
          <Route path="/release/:keyId" element={ <FormRoute Component={ReleaseForm} /> } />
          <Route path="/submitter/:keyId" element={ <FormRoute Component={SubmitterForm} /> } />
          <Route path="/missing/:keyId" element={ <FormRoute Component={MissingForm} /> } />
          <Route path="/unit/:keyId" element={ <FormRoute Component={UnitForm} /> } />
          <Route path="/daybook/:keyId" element={ <FormRoute Component={DaybookForm} /> } />
          <Route path="/report/:keyId" element={ <FormRoute Component={ReportForm} /> } />
          <Route path="/template/:keyId" element={ <FormRoute Component={TemplateForm} /> } />
          <Route path="/referral/:keyId" element={ <FormRoute Component={ReferralForm} /> } />
          <Route path="/claim/:keyId" element={ <FormRoute Component={ClaimForm} /> } />
          <Route path="/remittance/:keyId" element={ <FormRoute Component={RemittanceForm} /> } />
          <Route path="/sale/:keyId" element={ <FormRoute Component={SaleForm} /> } />
          <Route path="/saleorder/:keyId" element={ <FormRoute Component={SaleOrderForm} /> } />
          <Route path="/saleitem/:keyId" element={ <FormRoute Component={SaleItemForm} /> } />
          <Route path="/orders/:keyId" element={ <FormRoute Component={OrdersForm} /> } />
          <Route path="/purchase/:keyId" element={ <FormRoute Component={PurchaseForm} /> } />
          <Route path="/purchasereturn/:keyId" element={ <FormRoute Component={PurchaseReturnForm} /> } />
          <Route path="/purchasecredit/:keyId" element={ <FormRoute Component={PurchaseCreditForm} /> } />
          <Route path="/examtype/:keyId" element={ <FormRoute Component={ExamTypeForm} /> } />
          <Route path="/term/:keyId" element={ <FormRoute Component={TermForm} /> } />
          <Route path="/inventory/item/:keyId" element={ <ListRoute Component={ItemList} /> } />
          <Route path="/orders/item/:keyId" element={ <FormRoute Component={OrdersItem} /> } />
          <Route path="/purchase/item/:keyId" element={ <FormRoute Component={PurchaseItem} /> } />
          
          <Route path="/sale/print/:keyId" element={ <PrintRoute Component={SalePrint} /> } />
          <Route path="/orders/print/:keyId" element={ <PrintRoute Component={OrdersPrint} /> } />
          <Route path="/invoice/print/:keyId" element={ <PrintRoute Component={InvoicePrint} /> } />
          <Route path="/proforma/print/:keyId" element={ <PrintRoute Component={ProformaPrint} /> } />
          <Route path="/estimate/print/:keyId" element={ <PrintRoute Component={EstimatePrint} /> } />
          <Route path="/delivery/print/:keyId" element={ <PrintRoute Component={DeliveryPrint} /> } />
          <Route path="/dispense/print/:keyId" element={ <PrintRoute Component={DispensePrint} /> } />
          <Route path="/release/print/:keyId" element={ <PrintRoute Component={ReleasePrint} /> } />
          <Route path="/document/print/:keyId" element={ <PrintRoute Component={DocumentPrint} /> } />
          <Route path="/referral/print/:keyId" element={ <PrintRoute Component={ReferralPrint} /> } />
          <Route path="/exam/print/:keyId" element={ <PrintRoute Component={ExamPrint} /> } />
          <Route path="/exam/print2/:keyId" element={ <PrintRoute Component={ExamPrint2} /> } />
          <Route path="/laborder/print/:keyId" element={ <PrintRoute Component={LabOrderPrint} /> } />

          <Route path="/calendar/appointment" element={ <CalendarRoute Component={AppointmentCalendar} />} />
          <Route path="/calendar/schedule" element={ <CalendarRoute Component={ScheduleCalendar} />} />

          <Route path="/familylist/:keyId" element={ <FormRoute Component={FamilyList} /> } />
          <Route path="/familycredit/:keyId" element={ <FormRoute Component={FamilyCredit} /> } />
          <Route path="/merge/:keyId" element={ <FormRoute Component={ClientMerge} /> } />

          <Route path="/consent/print/11" element={ <PrintRoute Component={ConsentPrint11} /> } />
          <Route path="/consent/print/12" element={ <PrintRoute Component={ConsentPrint12} /> } />
          <Route path="/consent/print/13" element={ <PrintRoute Component={ConsentPrint13} /> } />
          <Route path="/consent/print/14" element={ <PrintRoute Component={ConsentPrint14} /> } />
          <Route path="/consent/print/15" element={ <PrintRoute Component={ConsentPrint15} /> } />
          <Route path="/consent/print/16" element={ <PrintRoute Component={ConsentPrint16} /> } />
          <Route path="/consent/print/17" element={ <PrintRoute Component={ConsentPrint17} /> } />

          <Route path="/reports/custom" element={ <ReportRoute Component={ReportCustom} />} />
          <Route path="/sample/signature" element={ <ReportRoute Component={SignatureForm} />} />
          <Route path="/sample/drawpad" element={ <ReportRoute Component={DrawingPadDemo} />} />
          <Route path="/sample/savetopdf" element={ <ReportRoute Component={SaveToPdfPage} />} />
          <Route path="/sample/SnipTool" element={ <ReportRoute Component={SnipTool} />} />
          <Route path="/sample/send-notification" element={ <FormRoute Component={SendNotification} />} />

          <Route path="/no-privilege" element={ <PrintRoute Component={NoPrivilege} /> }/>
     
     </Routes>
    </Router>
  );
};

export default App;
